class SiteLicense {
  constructor(data) {
    this.id = data.id
    this.name = data.n
    this.description = data.d
    this.type = 'license'
  }
}

export default SiteLicense
